<div
    class="col-xs-12 col-md-12 navy-blue page-heading-strip page-heading-bar no-padding background-white mobile-pos-fixed">
    <div class="col-xs-12 col-md-12">
        <h3 class="page-heading">
            <span class="img-span top-0 cursor-pointer mr-1">
                <img class="back-arrow" (click)="Back()" src="assets/back-arrow.png">
            </span>
            <span class="cursor-pointer" (click)="Back();">TRANSACTION STATUS </span>
            <app-need-help-drawer *ngIf="bflJourney" class="pull-right hide-mobile"></app-need-help-drawer>
        </h3>
    </div>
</div>

<!-- desktop view -->
<div class="container-fluid main-fix-footer-pad hide-mobile">
    <section *ngIf="showLoader">
        <app-loader></app-loader>
    </section>
    <div class="col-xs-12 col-md-9 col-lg-9 text-center review-bg">

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 div-center ">
            <img *ngIf="!!paymentStatus && paymentStatus !== 'Pending' && paymentStatus !== 'Initiated'"
                src="assets/paymentfailed.png" class="payment-failed-icon">
            <img *ngIf="paymentStatus === 'Pending' || paymentStatus === 'Initiated'" src="assets/pending.png"
                class="payment-failed-icon">
        </div>
        <ng-container *ngIf="!!paymentStatus && paymentStatus !== 'Pending' && paymentStatus !== 'Initiated'">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 div-center">
                <h2 class="payment-heading hurray">Failed!</h2>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label div-center">
                Payment unsuccessful. Please try again. Apologies for the inconvenience caused.
            </div>
        </ng-container>

        <ng-container *ngIf="paymentStatus === 'Pending' || paymentStatus === 'Initiated'">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 div-center">
                <h2 class="payment-heading ">Please Initiate your Payment</h2>
            </div>
            <div *ngIf="paymentStatus !== 'Initiated'"
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label div-center">
                Transaction could not be completed. If your account is debited, we will issue your policy
            </div>
        </ng-container>
        <!-- <div class="cards d-flex kyc-disclaimer ">
            <img src="../../../assets/icon/Info-icon-kyc.png" class="kyc-icon">
            <span class="kyc-top">{{disclaimer_msg}}</span>
        </div> -->



        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 inner-box top-spc-20">
            <div class="col-xs-11 col-md-11 top-bottom-20" *ngIf="errorMsg">
                <div class="col-xs-12 col-md-12">
                    <span class="text-danger fontStyle">{{errorMsg}}</span>
                </div>
            </div>
            <div class="col-xs-12 col-md-12 section-spc" *ngIf="planCode">
                <div class="col-xs-2 col-md-2 no-pad">
                    <img src="{{aemFragmentInfo?.logo?.variations[planCode.toLowerCase() +'_'+ quoteItemDetail.productVariantCode.toLowerCase()]?.value}}"
                        class="partner-logo" alt="bajaj-finserv-logo">
                    <div class="skelt-load loader" *ngIf="!isPartnerLogoLoaded"></div>
                </div>
                <div class="col-xs-9 col-md-10 no-padding">
                    <div class="partner-name">
                        {{aemFragmentInfo?.productName?.variations[planCode.toLowerCase() +'_'+
                        quoteItemDetail.productVariantCode.toLowerCase()]?.value}}
                    </div>
                    <div class="partner-loan-type">
                        {{aemFragmentInfo?.principleName?.variations[planCode.toLowerCase() +'_'+
                        quoteItemDetail.productVariantCode.toLowerCase()]?.value}}
                    </div>
                </div>
            </div>
            <div *ngIf="quoteItemDetail && quoteItemDetail.sumassuredamt"
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center top-spc-20">
                <span class="col-xs-6 col-md-6">Coverage</span>
                <span class="col-xs-6 col-md-6 amount-Label">
                    Rs.{{formatter.ConvertNumberToAmount(quoteItemDetail.sumassuredamt.toString())}}</span>

            </div>
            <div *ngIf="quoteItemDetailAddon && quoteItemDetailAddon.sumassuredamt"
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center top-spc-20">
                <span class="col-xs-6 col-md-6">Addon Coverage</span>
                <span class="col-xs-6 col-md-6 amount-Label">
                    Rs.{{formatter.ConvertNumberToAmount(quoteItemDetailAddon.sumassuredamt.toString())}}</span>

            </div>
            <div *ngIf="quoteItemDetail && quoteItemDetail.tenure"
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
                <span class="col-xs-6 col-md-6">Tenure</span>
                <span class="col-xs-6 col-md-6 amount-Label"> {{quoteItemDetail.tenure}} {{quoteItemDetail.tenure === 1
                    ? 'Year': 'Years'}}</span>
            </div>
            <div *ngIf="PaymentFailObject && PaymentFailObject.amount"
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
                <span class="col-xs-6 col-md-6">Total Premium</span>
                <span class="col-xs-6 col-md-6 amount-Label">
                    Rs.{{formatter.ToCurrency(PaymentFailObject.amount.toString())}}</span>
            </div>
            <!-- <div *ngIf="systemPaymentId && !paymentId"
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
                <span class="col-xs-6 col-md-6">Transaction ID</span>
                <span class="col-xs-6 col-md-6 amount-Label"> {{ systemPaymentId }} </span>
            </div> -->
            <div *ngIf="paymentId"
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
                <span class="col-xs-6 col-md-6">Transaction ID</span>
                <span class="col-xs-6 col-md-6 amount-Label"> {{ paymentId }} </span>
            </div>
            <div *ngIf="applicationId"
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
                <span class="col-xs-6 col-md-6">Application ID</span>
                <span class="col-xs-6 col-md-6 amount-Label"> {{ applicationId }} </span>
            </div>
            <div *ngIf="quoteId"
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
                <span class="col-xs-6 col-md-6">Quote ID</span>
                <span class="col-xs-6 col-md-6 amount-Label"> {{ quoteId }} </span>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 top-spc-20 margin-btm-20"
                *ngIf="(PaymentFailObject && !showLoader) || paymentRetry">
                <span (click)="googleAnalyticRetry();cleverTapPayloadPaymentStatus('RETRY')">
                    <app-payment-link [PaymentObject]="PaymentFailObject"
                        [ButtonName]="(paymentStatus === 'Pending' || paymentStatus === 'Initiated') ? 'PAY NOW' : 'RETRY PAYMENT'"
                        [emiFlag]="emiFlag" [paymentMode]="paymentMode" [paymentStatus]="paymentStatus"
                        [errorCode]="errorCode" [SummaryData]="summaryData" [isPaymentFailed]="true">
                    </app-payment-link>
                </span>
            </div>
        </div>

    </div>
</div>


<!-- mobile view -->
<section class="col main-content p-md-0 no-pad hide-desktop">
    <div class="flex-container col-md-12 no-pad">
        <div class="flex-item no-border-radius flex-error-item">
            <div class="col-md-12 error-section d-flex ">
                <div class="col-xs-3 col-4 col-md-3 center">
                    <img *ngIf="paymentStatus === 'Pending' || paymentStatus === 'Initiated'" style="height: 70px"
                        class="vehicles-logo" src="assets/pending.png">
                    <img *ngIf="!!paymentStatus && paymentStatus !== 'Pending' && paymentStatus !== 'Initiated'"
                        style="height: 70px" class="vehicles-logo" src="assets/paymentfailed.png">
                </div>
                <div class="col-md-9 col-9">
                    <h2 *ngIf="paymentStatus === 'Pending' || paymentStatus === 'Initiated'" class="mb-05 error-label">
                        Please Initiate your Payment</h2>
                    <h2 *ngIf="!!paymentStatus && paymentStatus !== 'Pending' && paymentStatus !== 'Initiated'"
                        class="mb-05 error-label">Failed!</h2>
                </div>
            </div>
        </div>


        <div class="flex-item no-border-radius flex-error-item pad-bottom-70">
            <p class="payment-desc" *ngIf="paymentStatus === 'Pending' && paymentStatus !== 'Initiated'">Transaction
                could not be completed. If your account is debited, we will issue your policy</p>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label div-center"
                *ngIf="!!paymentStatus && paymentStatus !== 'Pending' && paymentStatus !== 'Initiated'">
                Payment unsuccessful. Please try again. Apologies for the inconvenience caused.
            </div>

            <ng-container *ngIf="quoteDetail && aemFragmentInfo">
                <app-plan-card [selectedSumAssured]="selectedSumAssured" [selectedTenure]="quoteItemDetail.tenure"
                    [cashlessHospitalcount]="cashlessHospitalcount" [selectedSumAssuredAddOn]="selectedSumAssuredAddOn"
                    [tags]="quoteDetail.producttype" [totalGrossPremium]="quoteDetail.grossPremiumAmount"
                    [planCode]="quoteDetail.productCode" [variantCode]="quoteItemDetail.productVariantCode"
                    [aemFragmentInfo]="aemFragmentInfo">
                </app-plan-card>
            </ng-container>

            <!-- <div class="cards d-flex kyc-disclaimer-mobile ">
                <img src="../../../assets/icon/Info-icon-kyc.png" class="kyc-icon-mobile">
                <span class="kyc-top-mobile">{{disclaimer_msg}}</span>
            </div> -->

            <ng-container>
                <div class="col-md-12 error-section pad-top-bottom-1 d-flex justify-content-between mt-10">
                    <h2 class="mb-05 instapack-label">Policy Details</h2>
                </div>
                <div class="transaction-msg">
                    <!-- <div *ngIf="systemPaymentId && !paymentId">
                        <p class="instapack-desc">Transaction ID
                            <span class="flt-rght">
                                <div>
                                    <div>
                                        <h5 class="text-center font15 word-break">
                                            <div> {{ systemPaymentId }} </div>
                                        </h5>
                                    </div>
                                </div>
                            </span>
                        </p>
                    </div> -->

                    <div *ngIf="paymentId">
                        <p class="instapack-desc">Transaction ID
                            <span class="flt-rght">
                                <div>
                                    <div>
                                        <h5 class="text-center font15 word-break">
                                            <div> {{ paymentId }} </div>
                                        </h5>
                                    </div>
                                </div>
                            </span>
                        </p>
                    </div>

                    <div *ngIf="applicationId">
                        <p class="instapack-desc">Application ID
                            <span class="flt-rght">
                                <div>
                                    <div>
                                        <h5 class="text-center font15 word-break">
                                            <div> {{ applicationId }}</div>
                                        </h5>
                                    </div>
                                </div>
                            </span>
                        </p>
                    </div>

                    <div *ngIf="quoteId">
                        <p class="instapack-desc">Quote ID
                            <span class="flt-rght">
                                <div>
                                    <div>
                                        <h5 class="text-center font15 word-break">
                                            <div> {{ quoteId }} </div>
                                        </h5>
                                    </div>
                                </div>
                            </span>
                        </p>
                    </div>
                </div>

            </ng-container>

        </div>


        <div class="btn-fix-container" *ngIf="(PaymentFailObject && !showLoader) || paymentRetry">


            <span (click)="googleAnalyticRetry()">
                <app-payment-link [PaymentObject]="PaymentFailObject"
                    [ButtonName]="(paymentStatus === 'Pending' || paymentStatus === 'Initiated') ? 'PAY NOW' : 'RETRY PAYMENT'"
                    [emiFlag]="emiFlag" [paymentMode]="paymentMode" [paymentStatus]="paymentStatus"
                    [errorCode]="errorCode" [SummaryData]="summaryData" [isPaymentFailed]="true">
                </app-payment-link>
            </span>

        </div>


    </div>
</section>